

import React from "react";
import { motion } from "framer-motion";
import "../career.css";

export default function CareerPage() {

  // ------- JOB FORM SUBMIT -------
  const handleJobSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;

    const data = {
      name: form.name.value,
      email: form.email.value,
      phone: form.phone.value,
      why: form.why.value,
          //   resume: form.resume.files[0] ? form.resume.files[0].name : "",
    };

    await fetch("https://script.google.com/macros/s/AKfycbx8XnbGjPjbG9vPB6kiLEt-10Ik5rhcink3Yxhn1HgHtm4oYl7P-nOmiJZS2Jcvc6g/exec", {
      method: "POST",
      mode: "no-cors",
      body: JSON.stringify(data)
    });

    alert("Job Application Submitted Successfully!");
    form.reset();
  };

  // ------- AMBASSADOR FORM SUBMIT -------
  const handleAmbassadorSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;

    const data = {
      name: form.name.value,
      college: form.college.value,
      email: form.email.value,
      phone: form.phone.value,
      why: form.why.value,
    };

    await fetch("https://script.google.com/macros/s/AKfycbxR7jnMXvu-YsGYyT0fAFnfOiyCnc26nCCsO9dAf9DS2od3bMBNkVCOYcJCPnno-Fo/exec", {
      method: "POST",
      mode: "no-cors",
      body: JSON.stringify(data)
    });

    alert("Ambassador Form Submitted Successfully!");
    form.reset();
  };

  return (
    <div className="career-wrapper">
      <motion.h1
        className="career-title"
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9 }}
      >
        Career Opportunities
      </motion.h1>

      <motion.p
        className="career-subtext"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4 }}
      >
        Join our mission to empower students and build the future of learning.
      </motion.p>


      {/* ------------ JOB APPLICATION SECTION ------------ */}
      <motion.div
        className="career-section"
        initial={{ opacity: 0, x: -80 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.9 }}
      >
        <div className="career-text">
          <h2>Business Development Associate — Turn Conversations Into Growth</h2>
          <p>
      As a Business Development Associate at Acadme, you guide learners, understand goals, consult and inspire them toward career-transforming programs—building trust, driving growth, and creating real impact.
          </p>
              <h2>Responsibilities</h2>
          <ul>
            <li>✔ Connect with potential students via calls, WhatsApp, or email.</li>
            <li>✔ Understand their goals and recommend suitable Acadme programs.</li>
            <li>✔ Present offerings clearly and professionally.</li>
            <li>✔ Maintain lead records in CRM and follow up consistently.</li>
            <li>✔ Achieve monthly enrollment targets.</li>
            <li>✔ Build trust-based relationships, not one-time sales.</li>
            <li>✔ Coordinate with marketing and operations teams when required.</li>
          </ul>

        </div>

        <form className="career-form" onSubmit={handleJobSubmit}>
          <label>Full Name</label>
          <input type="text" name="name" placeholder="Enter your full name" required />

          <label>Email</label>
          <input type="email" name="email" placeholder="Enter your email" required />

          <label>Phone Number</label>
          <input type="number" name="phone" placeholder="Enter your phone number" required />

          {/* <label>Resume (PDF)</label>
          <input type="file" name="resume" accept="application/pdf" /> */}

          <label>Why Should We Hire You?</label>
          <textarea name="why" placeholder="Write in 2–3 sentences..." required></textarea>

          <motion.button
            whileHover={{ scale: 1.06 }}
            whileTap={{ scale: 0.9 }}
          >
            Submit Application
          </motion.button>
        </form>
      </motion.div>


      {/* ------------ CAMPUS AMBASSADOR SECTION ------------ */}
      <motion.div
        className="career-section"
        initial={{ opacity: 0, x: 80 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.9 }}
      >
        <div className="career-text">
          <h2>Acadme Campus Ambassador — Become the Face of Opportunity at Your Campus</h2>
          <p>
         The Acadme Campus Ambassador Program lets students lead, promote opportunities, build networks, gain leadership and communication skills, and connect peers to real-world growth and industry exposure.
          </p>
          <h2>Responsibilities</h2>
          <ul>
            <li>✔ Promote Acadme programs and learning opportunities in your college.</li>
            <li>✔ Organize seminars, workshops, or online sessions for students.</li>
            <li>✔ Build and manage college-based student communities.</li>
            <li>✔ Share Acadme updates on WhatsApp, LinkedIn, Instagram, or college groups.</li>
            <li>✔ Identify talented students who can benefit from Acadme programs.</li>
            <li>✔ Gather feedback and insights from your peers to improve offerings.</li>
            <li>✔ Coordinate with Acadme’s team and follow guidelines professionally.</li>
          </ul>

        </div>

        <form className="career-form" onSubmit={handleAmbassadorSubmit}>
          <label>Full Name</label>
          <input type="text" name="name" placeholder="Enter your full name" required />

          <label>College / University</label>
          <input type="text" name="college" placeholder="Enter your college name" required />

          <label>Email</label>
          <input type="email" name="email" placeholder="Enter your email" required />

          <label>Phone Number</label>
          <input type="number" name="phone" placeholder="Enter your phone number" required />

          <label>Why do you want to become an ambassador?</label>
          <textarea name="why" placeholder="Write in 2–3 sentences..." required></textarea>

          <motion.button
            whileHover={{ scale: 1.06 }}
            whileTap={{ scale: 0.9 }}
          >
            Apply Now
          </motion.button>
        </form>
      </motion.div>

    </div>
  );
}



